/**
 * En lugar de la caja de la IA, cuando ya no queda: qué pasó, cuándo vuelve y
 * cómo ampliarla. Sin «lo sentimos» ni rojo: es un plan que llegó a su tope,
 * no un error. La misma pieza en el asistente y en «Comienza tu proyecto».
 */
import { IconArrowUp } from '@tabler/icons-react'
import { useI18n } from '../../lib/i18n'

export function AiOutCard({ title, body, onOpenPlans, className = '' }: {
  title: string
  body: string
  onOpenPlans: () => void
  className?: string
}) {
  const { t } = useI18n()
  return (
    <div className={`dash-ai-out ${className}`.trim()} role="status">
      <strong>{title}</strong>
      <p>{body}</p>
      <button type="button" className="dash-primary-btn" onClick={onOpenPlans}>
        <IconArrowUp size={14} aria-hidden="true" />
        {t('ai.out.cta')}
      </button>
    </div>
  )
}
